import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { useFeature, usePublishDraft } from "../../hooks";
import { RequestsModal } from "../utils";

const FeatureName = "PUBLISH_BUTTON_ENABLED";
const PublishMessages = {
  publish: {
    publishButton: "Publish",
    requestHeader: "Publish draft",
    confirmationMessage: "Are you sure you want to publish the draft?",
    confirmText: "Confirm Publish",
    cancelText: "Cancel",
    publishingInformation: "Publishing",
  },
  request: {
    publishButton: "Request for publication",
    requestHeader: "Request publication",
    confirmationMessage: "Are you sure you want to request for publication?",
    confirmText: "Confirm request",
    cancelText: "Cancel",
    publishingInformation: "Requesting",
  },
};

export const PublishButton = ({
  draftId,
  draftTitle,
  datasetTypeCode,
  disabled,
}) => {
  const { enabled: publishButtonEnabled, isLoading } = useFeature(FeatureName);
  const [open, setOpen] = useState(false);
  const { loading } = usePublishDraft(draftId);

  const messages = PublishMessages.request;
  return (
    <>
      {!isLoading && publishButtonEnabled ? (
        loading ? (
          <Button fluid disabled>
            {messages.publishingInformation}
          </Button>
        ) : (
          <Button
            fluid
            secondary
            disabled={disabled ?? false}
            onClick={(event) => {
              event.preventDefault();
              setOpen(true);
            }}
          >
            {messages.publishButton}
          </Button>
        )
      ) : (
        <Button fluid secondary disabled={true}>
          {messages.publishButton}
        </Button>
      )}

      <RequestsModal
        open={open}
        onClose={() => setOpen(false)}
        draftId={draftId}
        draftTitle={draftTitle}
        datasetTypeCode={datasetTypeCode}
        requestHeader={messages.requestHeader}
        requestType="publish_draft"
        confirmationMessage={messages.confirmationMessage}
        confirmText={messages.confirmText}
        cancelText={messages.cancelText}
      />
    </>
  );
};

PublishButton.propTypes = {
  draftId: PropTypes.string.isRequired,
  draftTitle: PropTypes.string,
  datasetTypeCode: PropTypes.string,
  disabled: PropTypes.bool,
};
